module.exports = __webpack_public_path__ + "static/media/icon_boleto.5278f730.svg";